module.exports = __webpack_public_path__ + "static/assets/c73b30a718ff08201d4e75846d14d97c.png";